module.exports = __webpack_public_path__ + "img/case_02_2.e4ad10fb.png";